import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgetPassword from "./pages/ForgetPassword";    
import Dashboard from "./pages/Dashboard";
import TransporterRegister from "./pages/TransporterRegister";
import TransporterDashboard from "./pages/TransporterDashboard";
import AdminLayout from "./components/AdminLayout";
import Admin from "./pages/AdminDashboard";
import AdminUsers from "./pages/AdminUsers";
import AdminTransporters from "./pages/AdminTransporters";
import AdminBookings from "./pages/AdminBookings";
import AdminRevenue from "./pages/AdminRevenue";
import AdminSettings from "./pages/AdminSettings";
import Destinations from "./pages/Destinations";
import CovoituragePage from "./pages/Covoiturage";
import LocationPage from "./pages/Location";
import Tarifs from "./pages/Tarifs";
import Contact from "./pages/Contact";
import Conditions from "./pages/ConditionsGenerales";
import Confidentialite from "./pages/Confidentialite";


import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";

function App() {
  return (

    <AuthProvider>

      <Router>

        <Routes>

          {/* PUBLIC ROUTES */}
          <Route path="/" element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          } />

          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />

          <Route path="/register" element={
            <PublicRoute>
              <Register />
            </PublicRoute>
          } />

          <Route path="/forgot" element={
            <PublicRoute>
              <ForgetPassword />
            </PublicRoute>
          } />

          <Route path="/register-transporter" element={
            <PublicRoute>
              <TransporterRegister />
            </PublicRoute>
          } />
          <Route path="/destinations" element={
            <PublicRoute>
              <Destinations />
            </PublicRoute>
          } />
          <Route path="/covoiturage"  element={
            <PublicRoute>
              <CovoituragePage />
            </PublicRoute>
          } />
          <Route path="/location"  element={
            <PublicRoute>
              <LocationPage />
            </PublicRoute>
          } />
          <Route path="/tarifs"       element={
            <PublicRoute>
              <Tarifs />
            </PublicRoute>
          } />
          <Route path="/conditions"       element={
            <PublicRoute>
              <Conditions />
            </PublicRoute>
          } />
          <Route path="/confidentialite"       element={
            <PublicRoute>
              <Confidentialite />
            </PublicRoute>
          } />
          <Route path="/contact"      element={
            <PublicRoute>
              <Contact />
            </PublicRoute>
          } />
          {/* PROTECTED ROUTES */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Admin />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="transporters" element={<AdminTransporters />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="revenue" element={<AdminRevenue />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route
            path="/transporter/dashboard"
            element={
              <ProtectedRoute>
                <TransporterDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />

        </Routes>

      </Router>

    </AuthProvider>

  );
}

export default App;